import * as helper from "../utils/helper"
import * as request from "../utils/request"

interface MainParams {
  offerId: string
  sandbox?: string
}

interface CommonParams {
  [key: string]: string | number | undefined
}

/**
 * 组队pk接口说明
 * http://tapd.oa.com/StoreCloud/markdown_wikis/view/#1010158491010405205
 * @param params
 * @param extendParams
 * @returns {Promise<any>}
 */

export function teamProc(params: MainParams, extendParams: CommonParams = {}): Promise<any> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      t: +new Date()
    }
    data = Object.assign(data, extendParams)

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/team_proc`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
